// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__mbHFB","errors":"Errors_errors__2vC1O"};